// src/components/SidebarItem.jsx
import "./Template.scss";

import React, { useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { Nav } from "react-bootstrap";
import { isPathActive } from "./sidebarActive";

const SidebarItem = ({ label, path, handleClose, iconClass = "bi bi-grid-fill" }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const active = useMemo(() => isPathActive(location.pathname, path), [location.pathname, path]);

  const redirect = async () => {
    if (path === "suporte") {
      window.open("https://wa.me/5519981041860", "_blank");
      return;
    }

    if (path === "login") {
      localStorage.clear();
      navigate(path);
      handleClose?.();
      return;
    }

    if (path === "update-app") {
      try {
        if ("serviceWorker" in navigator) {
          const registrations = await navigator.serviceWorker.getRegistrations();
          await Promise.all(registrations.map((r) => r.unregister()));

          if ("caches" in window) {
            const cacheNames = await caches.keys();
            await Promise.all(cacheNames.map((name) => caches.delete(name)));
          }
        }
      } finally {
        window.location.reload();
      }
      return;
    }

    navigate(path);
    handleClose?.();
  };

  return (
    <div className={`hc-side-item ${active ? "is-active" : ""}`}>
      <Nav.Item>
        <Nav.Link onClick={redirect} className="nav-link hc-side-item__link">
          <i className={`${iconClass} hc-side-item__icon`} />
          <span className="hc-side-item__text">{label}</span>
        </Nav.Link>
      </Nav.Item>
    </div>
  );
};

export default SidebarItem;
